import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { Button, ButtonGroup, Tooltip } from '@mui/material';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import Tree from 'react-d3-tree';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { laboratoryService, locationService } from 'shared/services';
import { loadingActions } from 'store/slices/loadingSlice';
import { useAppDispatch } from 'store/store';
import { warehouseService } from 'features/inventory/warehouses/api/warehouse.service';
import { sectorService } from '../api/sector.service';
import { SectionHeader } from 'components/ui/typography';

export const TopologyTree = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.topology.tree';

  const dispatch = useAppDispatch();
  const [orgChart, setOrgChart] = useState<any>();

  const loadEntities = async () => {
    const laboratories = await laboratoryService.getAllBaseInformation();
    const sectors = await sectorService.getAllBaseInformation();
    const warehouses = await warehouseService.getAllBaseInformation();
    const locations = await locationService.getAllBaseInformation();
    return { laboratories, sectors, warehouses, locations };
  };

  useEffect(() => {
    dispatch(loadingActions.startLoading());
    loadEntities().then((res) => {
      const tmpOrgChart = {
        name: 'DISTRICT',
        children: []
      };

      res.laboratories.forEach((lab) => {
        tmpOrgChart.children.push({
          name: lab.code,
          children: res.sectors
            .filter((s) => s.laboratory === lab.id)
            .map((sector) => ({
              name: sector.code,
              children: res.warehouses
                .filter((w) => w.sector === sector.id)
                .map((w) => ({
                  name: w.code,
                  children: res.locations
                    .filter((location) => location.warehouse === w.id)
                    .map((location) => ({
                      name: location.code
                    }))
                }))
            }))
        });
      });

      setOrgChart(tmpOrgChart);
      dispatch(loadingActions.stopLoading());
    });
  }, []);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <ButtonGroup className="mr-4">
          <Tooltip title="Edit view">
            <NavLink to="..">
              <Button size="small">
                <ViewWeekIcon />
              </Button>
            </NavLink>
          </Tooltip>
        </ButtonGroup>
      }>
      <SectionHeader
        title={t(`${translationPrefix}.view.title`)}
        subtitle={t(`${translationPrefix}.view.subtitle`)}
      />
      <div
        id="treeWrapper"
        className="w-full h-[500px] relative bg-slate-50 border border-slate-200 rounded-xl shadow-inner transition-all duration-300 ease-in-out hover:border-slate-300">
        {orgChart && (
          <div className="w-full h-full animate-fade-in animate-duration-300">
            <Tree hasInteractiveNodes data={orgChart} orientation="vertical" />
          </div>
        )}
      </div>
    </TenantPage>
  );
};

export default TopologyTree;
